const product = JSON.parse( document.querySelector('#productJson').textContent )

const inquireButton = document.querySelector('[data-inquire]')
const form = document.querySelector('#ContactForm')

const formInput = form.querySelector('#ContactForm-body')

 const addClass = (el, className) => el.classList.add(className);
 const removeClass = (el, className) => el.classList.remove(className);


const inquire = (x) => {
  x.addEventListener('click', function(e) {
  	e.preventDefault()
    addClass(inquireButton, '#hidden')
    removeClass(form,'#hidden')
    formInput.value = `Inquiring about: ${product.title}`;
  })
}


inquireButton && inquire(inquireButton)